import { FormControl, FormGroup } from '@angular/forms';
import { CommonField } from '../models/Field';

// `FieldBase[]` -> `FormGroup`
export function customFieldsToFormGroup(fields: CommonField[]): FormGroup {
  let controls: Record<string, FormControl> = {};

  fields.forEach((field) => {
    controls[field.key] = new FormControl(
      field.value,
      Object.keys(field.rules).map((rKey) => field.rules[rKey].validator)
    );
  });

  return new FormGroup(controls);
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/utilities/customFieldsToFormGroup.ts